export const tagIds = {
  RESTAURANT: "2sn6dbecc3", // : "#D02800",
  ENTRADAS: "80ulgbfn21", // : "#00963D",
  ONEDAY: "k0bb01mkds", // : "#FF8802",
  COMPRAS: "chzlh8hklq" // : "#0979AA",
}

export const RESTAURANT = "2sn6dbecc3" // : "#D02800",
export const ENTRADAS = "80ulgbfn21"   // : "#00963D",
export const ONEDAY = "k0bb01mkds"     // : "#FF8802",
export const COMPRAS = "chzlh8hklq"    // : "#0979AA",

export function isRestaurant(product) {
  return product.tags[RESTAURANT]
}

export function isOneDay(product) {
  return product.tags[ONEDAY]
}
export function isCompra(product) {
  return product.tags[COMPRAS]
}

export function isEntradas(product) {
  return product.tags[ENTRADAS]
}

export function getType(product) {
  if (isRestaurant(product)) return 'restaurant'
  else if (isEntradas(product)) return 'ticket'
  else if (isOneDay(product)) return 'onedaytrip'
  else return false
}



// WEBPACK FOOTER //
// ./src/app/catalogo/tags.js